export interface ResponseDoc {
  id: number;
  name: string;
  alfresco_id: string;
  pathFolder: string;
  fileSize: number;
  alfrescoName: string;
  contentType: string;
  fileExtension: string;
}

export enum MimeType {
  PDF = 'application/pdf',
  PNG = 'image/png',
  JPG = 'image/jpeg',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  JPEG = 'image/jpeg',
  GIF = 'image/gif',
  SVG = 'image/svg+xml',
  TXT = 'text/plain',
  CSV = 'text/csv',
  JSON = 'application/json',
  XML = 'application/xml',
  HTML = 'text/html',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ZIP = 'application/zip',
  RAR = 'application/vnd.rar',
  MP3 = 'audio/mpeg',
  MP4 = 'video/mp4',
  AVI = 'video/x-msvideo',
  OCTET_STREAM = 'application/octet-stream',
}
